import { render, staticRenderFns } from "./howItem.vue?vue&type=template&id=0f202f70&scoped=true&"
import script from "./howItem.vue?vue&type=script&lang=js&"
export * from "./howItem.vue?vue&type=script&lang=js&"
import style0 from "./howItem.vue?vue&type=style&index=0&id=0f202f70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f202f70",
  null
  
)

export default component.exports